module.exports = __webpack_public_path__ + "img/mobile.cf500814.png";